module.exports = __webpack_public_path__ + "eeb2e16fac86d7ed69b6d116a4aa59cc.fbx";